import React from 'react';
import AuthLayout from 'layouts/AuthLayout';

const ForgotPasswordThankYouPage = () => {
    return (
        <AuthLayout>
            <div className="forgot-password-thankyou-page">
                <h5>Reset Password email sent to your inbox.</h5>
            </div>
        </AuthLayout>
    )
}

export default ForgotPasswordThankYouPage;